package ai.flowstorm.core.model

import kotlinx.serialization.Serializable

@Serializable
data class Persona(
    val name: String,
    val gender: Gender,
    val icon: String? = null,
    val background: String?  = null,
    val avatarId: String? = null,
    val dialogueId: String? = null,
    val brainId: String? = null,
    val isStrong: Boolean = false,
    val ttsConfig: TtsConfig? = null,
)